<setting-noticemail>
    <div class="wrapper page">
        <section class="page_wrap">
            <div class="page_inner">
                
                
                <h1 class="main_title page">解析完了通知メールの送信先設定</h1>
                <div class="plan_wrap">
                    <div class="setting_heading">
                        <h2 class="setting_title">現在の送信先アドレス</h2>
                    </div>
                    <div class="setting_detail">
                        <div class="setting_detail-inner" each="{ item in state.items }">
                            <div class="setting_address">{item.mail}</div>
                            <div class="setting_button-container">
                                <button class="button button-tertiary button-edit js-modal-open" type="button" value="編集する" data-target="noticemail-modal" onclick="{ (e) => onOpenModal(e, 'noticemail-modal', item) }">編集する</button>
                                <button class="button button-clear js-clear_address" type="button" value="クリア" onclick="{e => del(e, item.id)}">クリア</button>
                            </div>
                        </div><!--/.setting_detail-inner-->	
                    </div><!--/.setting_detail-->
                </div><!--/.plan_wrap-->
                <div class="plan_wrap last">
                    <div class="setting_heading">
                        <h2 class="setting_title">送信先アドレスの追加登録</h2>
                    </div>
                    <div class="setting_detail">
                        <div class="setting_detail-inner">
                            <div class="setting_address">
                                <div class="url_wrap">
                                    <input type="text" name="addr" class="url-input" >
                                </div><!--/.url_wrap-->
                            </div>
                            <div class="setting_button-container">
                                <button class="button button-tertiary button-add" type="button" value="登録する" onclick={(e)=> add(e)}>登録する</button>
                            </div>
                        </div><!--/.setting_detail-inner-->
                        
                    </div><!--/.setting_detail-->
                </div><!--/.plan_wrap-->
                
                <div class="unsubscribe is-show">
                    <div if={!state.disableNotice} onclick={toggleNotice} class="button button_quaternary js-unsubscribe"><a href="#">通知メールの停止</a></div>
                    <div if={state.disableNotice} onclick={toggleNotice} class="button button_quaternary js-unsubscribe"><a href="#">通知メールの配信再開</a></div>
                    <tooltip
                        text="解析が完了した際に「【chiyoco】解析が終了しました。」という件名の完了通知メールが届きます。<br>このメールの「完了時に送信する」という設定をオフにすることができます。"
                    >
                    </tooltip>
                </div><!--/.unsubscribe-->
                <noticemail-modal modal-id="noticemail-modal" api={state.api}></noticemail-modal>
            </div><!--/.page_inner-->
        </section><!--page_wrap-->
    </div><!--/.wrapper-->

  <script>
    import di from "dependeny-injection";
    import tooltip from "@tags/parts/tooltip.riot";
    import { api as NoticemailApi } from "@model/noticemail.js";
    import noticemailModal from "@tags/modal/setting/noticemail-modal.riot";

    export default {
        components: {
            tooltip,
            "noticemail-modal": noticemailModal
        },
        state: {
            items: [],
            disableNotice: false,
            api: NoticemailApi
        },
        toggleNotice(){
            NoticemailApi.toggleNotice();
        },
        onMounted() {
            NoticemailApi.on('fetched:items', (data) => {
                this.state.items = data.list;
                this.state.disableNotice = data.disableNotice;
                this.update()
            });
            NoticemailApi.on('added', (success, message) => {
                if (success) {
                    let input = this.root.querySelector('input[name=addr]');
                    input.value = '';
                    NoticemailApi.items();
                } else {
                    alert(message);
                }
                
            });
            NoticemailApi.on('edited', (success, data) => {
                if (!success) {
                    alert(data);
                    return;
                } else {
                    NoticemailApi.items();
                }
                
            });
            NoticemailApi.on('deleted', (data) => {
                NoticemailApi.items();
            });
            NoticemailApi.on('toggled', (data) => {
                NoticemailApi.items();
            });
            NoticemailApi.items();
        },
        onOpenModal(e, modalId, item) {
            NoticemailApi.setItem(item);
            window.$(this.$(`#${modalId}`)).fadeIn(100);
        },
        add(e) {
            let input = this.root.querySelector('input[name=addr]');
            let addr = input.value;
            NoticemailApi.add(addr);
        },
        del(e, id){
            NoticemailApi.del(id);
        }

    }
  </script>
</setting-noticemail>
